import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IDiscountProps {
  originalPrice: string;
  discountPercent: string;
  isCompact?: boolean;
}

export const Discount = ({ originalPrice, discountPercent }: IDiscountProps) => {
  return (
    <div className={styles['discount']} data-testid="discount">
      <span className={styles['discount-percent']}>
        <UIText3 color="text-inverted-default" data-testid="discount-percent">
          {discountPercent}
        </UIText3>
      </span>
      <span className={styles['original-price']}>
        <UIText3 color="text-secondary-default" data-testid="discount-original-price">
          {originalPrice}
        </UIText3>
      </span>
    </div>
  );
};
